/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Newsletter,
  NewsletterContent,
  NewsletterCount,
  RestResult,
} from '../models';
import {
    NewsletterFromJSON,
    NewsletterToJSON,
    NewsletterContentFromJSON,
    NewsletterContentToJSON,
    NewsletterCountFromJSON,
    NewsletterCountToJSON,
    RestResultFromJSON,
    RestResultToJSON,
} from '../models';

export interface CountNewsletterRequest {
    clientName: string;
}

export interface GetNewsletterRequest {
    clientName: string;
    nlId: string;
}

export interface IncreaseDownloadCountRequest {
    clientName: string;
    nlId: string;
}

export interface ListNewsletterRequest {
    clientName: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class NewsletterControllerApi extends runtime.BaseAPI {

    /**
     */
    async countNewsletterRaw(requestParameters: CountNewsletterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NewsletterCount>> {
        if (requestParameters.clientName === null || requestParameters.clientName === undefined) {
            throw new runtime.RequiredError('clientName','Required parameter requestParameters.clientName was null or undefined when calling countNewsletter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/newsletter/{clientName}/count`.replace(`{${"clientName"}}`, encodeURIComponent(String(requestParameters.clientName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewsletterCountFromJSON(jsonValue));
    }

    /**
     */
    async countNewsletter(clientName: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NewsletterCount> {
        const response = await this.countNewsletterRaw({ clientName: clientName }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNewsletterRaw(requestParameters: GetNewsletterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NewsletterContent>> {
        if (requestParameters.clientName === null || requestParameters.clientName === undefined) {
            throw new runtime.RequiredError('clientName','Required parameter requestParameters.clientName was null or undefined when calling getNewsletter.');
        }

        if (requestParameters.nlId === null || requestParameters.nlId === undefined) {
            throw new runtime.RequiredError('nlId','Required parameter requestParameters.nlId was null or undefined when calling getNewsletter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/newsletter/{clientName}/{nlId}`.replace(`{${"clientName"}}`, encodeURIComponent(String(requestParameters.clientName))).replace(`{${"nlId"}}`, encodeURIComponent(String(requestParameters.nlId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewsletterContentFromJSON(jsonValue));
    }

    /**
     */
    async getNewsletter(clientName: string, nlId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NewsletterContent> {
        const response = await this.getNewsletterRaw({ clientName: clientName, nlId: nlId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async increaseDownloadCountRaw(requestParameters: IncreaseDownloadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RestResult>> {
        if (requestParameters.clientName === null || requestParameters.clientName === undefined) {
            throw new runtime.RequiredError('clientName','Required parameter requestParameters.clientName was null or undefined when calling increaseDownloadCount.');
        }

        if (requestParameters.nlId === null || requestParameters.nlId === undefined) {
            throw new runtime.RequiredError('nlId','Required parameter requestParameters.nlId was null or undefined when calling increaseDownloadCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/newsletter/{clientName}/{nlId}/increase-downlaod-count`.replace(`{${"clientName"}}`, encodeURIComponent(String(requestParameters.clientName))).replace(`{${"nlId"}}`, encodeURIComponent(String(requestParameters.nlId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RestResultFromJSON(jsonValue));
    }

    /**
     */
    async increaseDownloadCount(clientName: string, nlId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RestResult> {
        const response = await this.increaseDownloadCountRaw({ clientName: clientName, nlId: nlId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listNewsletterRaw(requestParameters: ListNewsletterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Newsletter>>> {
        if (requestParameters.clientName === null || requestParameters.clientName === undefined) {
            throw new runtime.RequiredError('clientName','Required parameter requestParameters.clientName was null or undefined when calling listNewsletter.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/newsletter/{clientName}`.replace(`{${"clientName"}}`, encodeURIComponent(String(requestParameters.clientName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NewsletterFromJSON));
    }

    /**
     */
    async listNewsletter(clientName: string, page?: number, pageSize?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Newsletter>> {
        const response = await this.listNewsletterRaw({ clientName: clientName, page: page, pageSize: pageSize }, initOverrides);
        return await response.value();
    }

}
